export default `
    <div id="#= data.id #" name="#= data.id #" class="editable-label-container #= data.containerClasses || ""# #=data.bsc||""#">
        <span # if (data.labelId) { # id="#= data.labelId #" # } # class="display-label bind-value #= data.labelClasses #" # if (data.labelBind) { # data-bind="#= data.labelBind #" # } #  data-label-for-id="#= data.id #">
        </span>
        <div class="editable-input-container">
            <span class="editable-label bind-label #= data.editableLabelClasses #" 
                # if (data.editableLabelBind) { # data-bind="#= data.editableLabelBind #" # } # 
                # if (data.toolTip) { # title="#= data.toolTip #" # } #
            >
            </span>
            <input # if (data.inputId) { # id="#= data.inputId #" name="#= data.inputId #" # } #  data-label-for-id="#= data.id #"  autocomplete="no!" class="pane-field-input editable-input bind-value #= data.editableInputClasses #" 
                # if (data.editableInputBind) { # data-bind="#= data.editableInputBind #" # } # 
                # if (data.maxLength) { # max-length="#= data.maxLength #" # } #
                # if (data.zRole) { # data-z-role="#= data.zRole #" # } #
                # if (data.dataFormat) { # data-format="#= data.dataFormat #" # } # 
                # if (data.required) { # required="#= data.required #" # } #
                # if (data.disabled) { # disabled="disabled" # } #
            />
        </div>
    </div>
`;
